/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './AccountDisplayCard.scss';

import React from 'react';
import { getAccountsById } from 'state/account/AccountSelectors';
import { connect } from 'react-redux';
import Dot from '../Dot/Dot';
import AccountLabel from '../AccountLabel/AccountLabel';
import AccountOwners from '../AccountOwners/AccountOwners';

const AccountDisplayCard = ({
  accountId,
  accountsById,
  headerPreText,
  headerPostText,
  sideBar,
  children
}) => {
  const account = accountsById[accountId];

  if (!account) {
    return null;
  }
  const { accountChecksum, accountType, accountName, accountNumber, ticker } =
    account;
  return (
    <div className="account-display-card">
      <div className="header-level-data">
        <div className="account-info">
          <div className="account-type">
            {headerPreText} {accountType} {headerPostText}
          </div>
          <div className="account-details">
            <div className="account-name-and-ticker">
              <div className="account-name">{accountName}</div>
              {ticker && <div className="ticker">({ticker})</div>}{' '}
            </div>
            <div className="account-sub-info">
              <div className="account-number blocked_data">{`${accountNumber}-${accountChecksum}`}</div>
              <Dot sizeInPixels={2} />
              <AccountOwners
                account={account}
                delimiter={<Dot sizeInPixels={2} />}
              />
            </div>
            <AccountLabel accountId={accountId} />
          </div>
        </div>
        {sideBar && <div className="side-bar">{sideBar}</div>}
      </div>
      {children}
    </div>
  );
};

const mapStateToProps = (state) => ({
  accountsById: getAccountsById(state)
});

export default connect(mapStateToProps)(AccountDisplayCard);
